<template>
    <div
        class="h-full w-full mx-auto flex"
        style="background: #E6F2F3"
    >
        <div class="h-full w-full max-w-7xl mx-auto pb-20">
            <div class="mx-20 2xl:mx-0">
                <div class="flex mb-10 pt-20 items-center justify-between">
                    <div class="flex items-center gap-x-4">
                        <svg
                            width="30"
                            height="28"
                            viewBox="0 0 30 28"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M14.049 1.92664C14.3483 1.00538 15.6517 1.00538 15.951 1.92664L18.368 9.36437C18.5019 9.77636 18.8858 10.0553 19.319 10.0553L27.1396 10.0556C28.1083 10.0556 28.5111 11.2952 27.7274 11.8646L21.4006 16.4617C21.0501 16.7163 20.9035 17.1676 21.0373 17.5796L23.4537 25.0176C23.753 25.9388 22.6986 26.7049 21.9149 26.1356L15.5878 21.539C15.2373 21.2844 14.7627 21.2844 14.4122 21.539L8.08508 26.1356C7.30138 26.7049 6.24695 25.9388 6.54626 25.0176L8.96267 17.5796C9.09652 17.1676 8.94987 16.7163 8.59942 16.4617L2.27261 11.8646C1.48894 11.2952 1.8917 10.0556 2.86038 10.0556L10.681 10.0553C11.1142 10.0553 11.4981 9.77636 11.632 9.36437L14.049 1.92664Z"
                                fill="#E6F2F3"
                                stroke="#212121"
                                stroke-width="2"
                            />
                        </svg>
                        <h1 class="text-3xl">
                            Høydepunkter
                        </h1>
                    </div>
                    <button
                        v-if="selectedCards.length > 0"
                        type="button"
                        class="bg-primary-dark text-white rounded-md py-2 px-4 border border-font hover:bg-primary"
                        @click="highlightsModal = true"
                    >
                        Change highlights
                    </button>
                    <button
                        v-if="cards.length > 0 && selectedCards.length < 1"
                        type="button"
                        class="bg-primary-dark text-white rounded-md py-2 px-4 border border-font hover:bg-primary"
                        @click="highlightsModal = true"
                    >
                        Choose highlights
                    </button>
                </div>

                <div v-if="selectedCards.length > 0" class="">
                    <div class="h-full w-full rounded-lg grid grid-cols-3 gap-x-14 gap-y-6">
                        <div v-for="selected in selectedCards.slice(0,6)" :key="selected.id">
                            <div class="flex flex-col">
                                <figure class="lg:h-48">
                                    <img
                                        class="w-full md:h-36 lg:h-full rounded-t-lg object-cover"
                                        :src="selected.img"
                                        :alt="selected.alt"
                                    >
                                </figure>
                                <div class="bg-white h-28 rounded-b-lg p-2 lg:p-4">
                                    <h2 v-if="selected.title" class="mt-3 text-md lg:text-xl">
                                        {{ selected.title }}
                                    </h2>
                                    <div class="mt-2 text-sm lg:text-md xl:flex">
                                        <p class="text-gray-600 flex items-center">
                                            <svg
                                                width="12"
                                                height="13"
                                                class="mr-2"
                                                viewBox="0 0 12 13"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M0.75 3.27177C0.75 2.61242 1.27233 2.0779 1.91667 2.0779H10.0833C10.7277 2.0779 11.25 2.61242 11.25 3.27177V10.435C11.25 11.0944 10.7277 11.6289 10.0833 11.6289H1.91667C1.27233 11.6289 0.75 11.0944 0.75 10.435V3.27177Z"
                                                    fill="white"
                                                />
                                                <path
                                                    d="M3.66667 3.27177V0.884033M8.33333 3.27177V0.884033M3.08333 5.65952H8.91667M1.91667 11.6289H10.0833C10.7277 11.6289 11.25 11.0944 11.25 10.435V3.27177C11.25 2.61242 10.7277 2.0779 10.0833 2.0779H1.91667C1.27233 2.0779 0.75 2.61242 0.75 3.27177V10.435C0.75 11.0944 1.27233 11.6289 1.91667 11.6289Z"
                                                    stroke="#01798A"
                                                    stroke-width="1.3166"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                            </svg>
                                            <FormattedDate :date="selected.date" />
                                        </p>
                                        <p class="text-gray-600 flex items-center xl:ml-3">
                                            <svg
                                                width="12"
                                                height="13"
                                                class="mr-2"
                                                viewBox="0 0 12 13"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M9.30048 9.03628C8.88345 9.46304 8.11904 10.2453 7.4309 10.9494C6.6463 11.7523 5.35485 11.7522 4.57024 10.9493C3.89547 10.2588 3.14306 9.48883 2.70082 9.03628C0.878373 7.17134 0.878373 4.14768 2.70082 2.28274C4.52327 0.417798 7.47804 0.417798 9.30048 2.28274C11.1229 4.14768 11.1229 7.17134 9.30048 9.03628Z"
                                                    stroke="#01798A"
                                                    stroke-width="1.16667"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                                <path
                                                    d="M7.75065 5.65951C7.75065 6.64854 6.96715 7.45031 6.00065 7.45031C5.03415 7.45031 4.25065 6.64854 4.25065 5.65951C4.25065 4.67047 5.03415 3.86871 6.00065 3.86871C6.96715 3.86871 7.75065 4.67047 7.75065 5.65951Z"
                                                    stroke="#01798A"
                                                    stroke-width="1.16667"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                            </svg>
                                            {{ selected.destination }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <Modal
        :show="highlightsModal"
        @cancel="close"
        :size="`max-w-6xl`"
        :cards="cards"
    >
        <div
            class="w-full overflow-y-scroll rounded-lg p-10"
            :class="[cards.length < 4 ? 'h-auto' : 'h-150']"
            style="background: #E6F2F3"
        >
            <div class="grid grid-cols-3 gap-x-14 gap-y-6">
                <div v-for="card in cards" :key="card.id">
                    <button
                        type="button"
                        @click="selectOrDeselect(card)"
                        class="hover:ring-2 hover:rounded-lg"
                    >
                        <div class="flex flex-col" :class="{'ring-2 rounded-lg opacity-75': isSelected(card)}">
                            <figure class="lg:h-48">
                                <img
                                    class="w-full md:h-36 lg:h-full rounded-t-lg object-cover"
                                    :src="card.img"
                                    :alt="card.alt"
                                >
                            </figure>
                            <div class="bg-white h-28 rounded-b-lg p-2 lg:p-4">
                                <h2 class="mt-3 text-md text-left lg:text-xl">
                                    {{ card.title }}
                                </h2>
                                <div class="mt-2 text-sm lg:text-md xl:flex">
                                    <p class="text-gray-600 flex items-center">
                                        <svg
                                            width="12"
                                            height="13"
                                            class="mr-2"
                                            viewBox="0 0 12 13"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M0.75 3.27177C0.75 2.61242 1.27233 2.0779 1.91667 2.0779H10.0833C10.7277 2.0779 11.25 2.61242 11.25 3.27177V10.435C11.25 11.0944 10.7277 11.6289 10.0833 11.6289H1.91667C1.27233 11.6289 0.75 11.0944 0.75 10.435V3.27177Z"
                                                fill="white"
                                            />
                                            <path
                                                d="M3.66667 3.27177V0.884033M8.33333 3.27177V0.884033M3.08333 5.65952H8.91667M1.91667 11.6289H10.0833C10.7277 11.6289 11.25 11.0944 11.25 10.435V3.27177C11.25 2.61242 10.7277 2.0779 10.0833 2.0779H1.91667C1.27233 2.0779 0.75 2.61242 0.75 3.27177V10.435C0.75 11.0944 1.27233 11.6289 1.91667 11.6289Z"
                                                stroke="#01798A"
                                                stroke-width="1.3166"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            />
                                        </svg>
                                        <FormattedDate :date="card.date" />
                                    </p>
                                    <p class="text-gray-600 flex items-center xl:ml-3">
                                        <svg
                                            width="12"
                                            height="13"
                                            class="mr-2"
                                            viewBox="0 0 12 13"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M9.30048 9.03628C8.88345 9.46304 8.11904 10.2453 7.4309 10.9494C6.6463 11.7523 5.35485 11.7522 4.57024 10.9493C3.89547 10.2588 3.14306 9.48883 2.70082 9.03628C0.878373 7.17134 0.878373 4.14768 2.70082 2.28274C4.52327 0.417798 7.47804 0.417798 9.30048 2.28274C11.1229 4.14768 11.1229 7.17134 9.30048 9.03628Z"
                                                stroke="#01798A"
                                                stroke-width="1.16667"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            />
                                            <path
                                                d="M7.75065 5.65951C7.75065 6.64854 6.96715 7.45031 6.00065 7.45031C5.03415 7.45031 4.25065 6.64854 4.25065 5.65951C4.25065 4.67047 5.03415 3.86871 6.00065 3.86871C6.96715 3.86871 7.75065 4.67047 7.75065 5.65951Z"
                                                stroke="#01798A"
                                                stroke-width="1.16667"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            />
                                        </svg>
                                        {{ card.destination }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </button>
                </div>
            </div>
            <div class="w-full flex justify-end pt-5">
                <button
                    type="button"
                    @click="highlightsModal = false"
                    class="bg-primary-dark text-white rounded-md py-2 px-4 border border-font hover:bg-primary"
                >
                    Select
                </button>
            </div>

        </div>
    </Modal>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import Modal from '../Modal/CalendarModal'
import FormattedDate from '@/ComponentsDeprecated/Time/FormattedDate';

const highlightsModal = ref(false)
const selectedCards = ref([])

const props = defineProps({
    cards: {
        type: Array
    }
})

function isSelected(obj) {
    const object = selectedCards.value.filter(o => {
        return o.id === obj.id
    })
    return object.length > 0
}

function selectOrDeselect(obj) {
    const object = selectedCards.value.filter(o => {
        return o.id === obj.id
    })
    if(object.length === 0) {
        selectedCards.value.push(obj);
    }
    else {
        selectedCards.value.splice(selectedCards.value.indexOf(object[0]), 1);
    }
}

const closeOnEscape = (e) => {
    if (e.key === 'Escape') {
        highlightsModal.value = false
    }
};

onMounted(() => document.addEventListener('keydown', closeOnEscape));
onUnmounted(() => document.removeEventListener('keydown', closeOnEscape));

</script>
